import styled from '@emotion/styled'
import ElevationDown from 'assets/icons/elevation_down.svg'
import ElevationUp from 'assets/icons/elevation_up.svg'
import NordicWalk from 'assets/icons/nordic_walking.svg'
import Walk from 'assets/icons/walk.svg'

const iconScaleCoeff = 0.83

export const DistanceOrElevationLabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`
export const ElevationDownIcon = styled(ElevationDown)`
  transform: scale(${iconScaleCoeff});
`
export const ElevationUpIcon = styled(ElevationUp)`
  transform: scale(${iconScaleCoeff});
`
export const WalkIcon = styled(Walk)`
  transform: scale(${iconScaleCoeff});
`
export const NordicWalkIcon = styled(NordicWalk)`
  transform: scale(${iconScaleCoeff});
`
